import { render, staticRenderFns } from "./handoverWithdrawal.vue?vue&type=template&id=3c58f920&"
import script from "./handoverWithdrawal.vue?vue&type=script&lang=js&"
export * from "./handoverWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports